<template>
  <div
    :class="['activity-new-double-good', { 'small-card': isSmall }]"
    @click="goDetail"
  >
    <sku-img
      :img-url="skuImg.imgUrl"
      :image-width="goodWidth"
      :sku-img="skuImg"
      :bottom-tag="bottomTag"
      :rank="false"
      :show-countdown="showCountdown"
      :remain-time="remainTime"
      :remain-title="remainTitle"
      :border-radius="0"
    />
    <div class="content">
      <sku-header :sku="good" :show-sku-all-format-tags="isMultiSku" />
      <price-tag
        v-if="priceTag"
        :tag="priceTag"
        :sub="priceSub"
        :tag-info="isSmall ? priceTagInfo : {}"
      />
      <div class="price-row">
        <template v-if="isMultiSku">
          <div v-if="skuPrice.priceShield" class="price-shield">
            {{ skuPrice.priceShieldText }}
          </div>
          <good-price v-else :sku="good" />
          <div v-if="isSmall" class="small-buy" @click.stop="goDetail">
            抢购
          </div>
          <div v-else class="specification" @click.stop>
            <open-ssu-btn
              :bg-start-color="'#F03100'"
              :bg-end-color="'#F03100'"
              :border-radius="0.12"
              :width="1.36"
              :height="0.64"
              @openChange="openSpecification"
            />
          </div>
        </template>
        <template v-else>
          <div v-if="ssu.ssuPrice.priceShield" class="price-shield">
            {{ ssu.ssuPrice.priceShieldText }}
          </div>
          <good-price v-else :ssu="ssu" />
          <div v-if="isSmall" class="small-buy" @click.stop="goDetail">
            抢购
          </div>
          <div v-else class="operator" @click.stop>
            <new-operator
              use-red-add-cart
              red-add-cart-compact
              :btn-width="0.56"
              :computed-s-su="ssu"
              :show-can-not-buy="false"
              @add="addCart"
              @subtract="subtractCart"
            />
          </div>
        </template>
      </div>
      <ssu-deposit v-if="!isMultiSku" show-deposit :ssu="ssu" />
    </div>

    <van-popup
      v-if="isMultiSku"
      v-model="showSpecification"
      round
      position="bottom"
      class="activity-sku-popup"
      :close-on-click-overlay="true"
      :overlay-style="popupOverlayStyle"
    >
      <div @click.stop>
        <div class="popup-header">
          <span class="popup-title">选择规格</span>
          <span class="popup-close" @click.stop="showSpecification = false"
            >×</span
          >
        </div>
        <div class="popup-scroll">
          <div class="popup-main">
            <sku-img
              :img-url="skuImg.imgUrl"
              :image-width="popupImageWidth"
              :sku-img="skuImg"
              :bottom-tag="bottomTag"
              :rank="false"
              :show-countdown="false"
              :border-radius="8"
            />
            <div class="popup-info">
              <sku-header :sku="good" />
              <div
                v-for="(popupSsu, index) in ssuList"
                :key="popupSsu.ssuId || index"
                class="popup-ssu"
              >
                <price-tag
                  v-if="ssuPriceTag(popupSsu)"
                  :tag="ssuPriceTag(popupSsu)"
                  :sub="ssuPriceSub(popupSsu)"
                />
                <div class="popup-price-row">
                  <div
                    v-if="popupSsu.ssuPrice && popupSsu.ssuPrice.priceShield"
                    class="price-shield"
                  >
                    {{ popupSsu.ssuPrice.priceShieldText }}
                  </div>
                  <good-price v-else :ssu="popupSsu" />
                  <div class="popup-operator" @click.stop>
                    <new-operator
                      use-red-add-cart
                      :use-icon="false"
                      btn-text="加购物车"
                      :btn-width="1.36"
                      :show-simple-count="true"
                      :computed-s-su="popupSsu"
                      :show-can-not-buy="false"
                      @keyboard-open="showNumberKeyboard = true"
                      @keyboard-close="showNumberKeyboard = false"
                      @add="popupAddCart(popupSsu, index)"
                      @subtract="popupSubtractCart(popupSsu, index)"
                    />
                  </div>
                </div>
                <ssu-deposit show-deposit :ssu="popupSsu" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import SkuImg from '@/common/widgets/newGood/skuImg'
import SkuHeader from '@/common/widgets/newGood/skuHeader'
import PriceTag from '@/common/widgets/newGood/priceTag'
import GoodPrice from '@/common/widgets/newGood/goodPrice'
import SsuDeposit from '@/common/widgets/newGood/ssuDeposit'
import NewOperator from '@/common/widgets/newOperator/newIndex.vue'
import OpenSsuBtn from '@/common/widgets/open_ssu_btn/index.vue'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'

export default {
  name: 'ActivityNewDoubleGood',
  components: {
    SkuImg,
    SkuHeader,
    PriceTag,
    GoodPrice,
    SsuDeposit,
    NewOperator,
    OpenSsuBtn
  },
  props: {
    good: {
      type: Object,
      default: () => ({})
    },
    goodWidth: {
      type: Number,
      default: 0
    },
    skuIndex: {
      type: Number,
      default: 0
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showSpecification: false,
      showNumberKeyboard: false
    }
  },
  computed: {
    ssu() {
      return this.good?.ssuInfo || this.good?.ssuList?.[0] || {}
    },
    isMultiSku() {
      return (this.good?.ssuList || []).length > 1
    },
    ssuList() {
      return this.good?.ssuList || []
    },
    skuImg() {
      return this.good?.skuImg || {}
    },
    skuPrice() {
      return this.good?.skuPrice || {}
    },
    popupImageWidth() {
      return Math.min(this.goodWidth || 120, 120)
    },
    bottomTag() {
      return this.skuImg?.bottomTag?.[0] || null
    },
    remainTimeItem() {
      return this.skuImg?.leftBottomTag?.find(
        tag => tag.remainTime !== undefined && tag.remainTime !== null
      )
    },
    remainTime() {
      return this.remainTimeItem?.remainTime || 0
    },
    showCountdown() {
      return this.remainTime > 0
    },
    remainTitle() {
      return this.remainTimeItem?.tag || ''
    },
    priceTag() {
      return this.priceTagInfo?.tag || ''
    },
    priceSub() {
      return this.priceTagInfo?.suffixText || ''
    },
    priceTagInfo() {
      const price = this.isMultiSku ? this.skuPrice : this.ssu?.ssuPrice
      return price?.priceUpperTag?.[0] || {}
    },
    popupOverlayStyle() {
      return {
        backgroundColor: this.showNumberKeyboard
          ? 'transparent'
          : 'rgba(0, 0, 0, 0.4)'
      }
    }
  },
  methods: {
    ssuPriceTag(ssu) {
      return ssu?.ssuPrice?.priceUpperTag?.[0]?.tag || ''
    },
    ssuPriceSub(ssu) {
      return ssu?.ssuPrice?.priceUpperTag?.[0]?.suffixText || ''
    },
    openSpecification() {
      this.$emit('chooseSpec', this.good, this.skuIndex)
      this.showSpecification = true
    },
    popupAddCart(ssu, ssuIndex) {
      this.$emit('popupaddcart', {
        good: this.good,
        ssu,
        skuIndex: this.skuIndex,
        ssuIndex
      })
    },
    popupSubtractCart(ssu, ssuIndex) {
      this.$emit('popupsubtractcart', {
        good: this.good,
        ssu,
        skuIndex: this.skuIndex,
        ssuIndex
      })
    },
    addCart() {
      this.$emit('addcart', this.good, this.skuIndex)
    },
    subtractCart() {
      this.$emit('subtractcart', this.good, this.skuIndex)
    },
    goDetail() {
      this.$emit('click', this.good, this.skuIndex)
      this.$nativeRedirect(nativeRoutes.goodsDetail, {
        id: this.ssu.ssuId,
        tickReferId: this.$trackMap.activityGoods.goDetail
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-new-double-good {
  overflow: hidden;

  background-color: #fff;
  border-radius: 0.16rem;
}

.content {
  min-height: 1.72rem;
  padding: 0.16rem 0.16rem 0.2rem;
  box-sizing: border-box;
}

.price-tag {
  margin-top: 0.08rem;
}

.price-row {
  display: flex;
  align-items: center;
  min-height: 0.64rem;
}

.operator,
.specification,
.popup-operator {
  margin-left: auto;
  flex: none;
}

.small-buy {
  width: 1.04rem;
  height: 0.52rem;

  margin-left: auto;

  border-radius: 0.28rem;

  background-image: linear-gradient(90deg, #ff5e01, #fe2e31);

  font-size: 0.28rem;
  font-weight: 500;
  line-height: 0.52rem;
  text-align: center;
  color: #fff;

  flex: none;
}

.price-shield {
  font-size: 0.24rem;
  line-height: 0.32rem;
  color: #f03100;
}

::v-deep .ssu-deposit {
  margin-top: 0.08rem;
}

.popup-header {
  position: relative;
  display: flex;
  height: 1.04rem;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f5f5f5;
}

.popup-title {
  font-size: 0.32rem;
  font-weight: 500;
  color: #262626;
}

.popup-close {
  position: absolute;
  top: 0.22rem;
  right: 0.24rem;
  width: 0.6rem;
  height: 0.6rem;
  font-size: 0.48rem;
  font-weight: 300;
  line-height: 0.52rem;
  text-align: center;
  color: #8c8c8c;
}

.popup-scroll {
  max-height: 11.6rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.popup-main {
  display: flex;
  width: 100%;
  padding: 0.48rem 0.16rem 0.6rem;
  box-sizing: border-box;
  align-items: flex-start;
}

.popup-info {
  width: 0;
  margin-left: 0.24rem;
  flex: 1;
}

.popup-ssu {
  padding: 0.16rem 0;
}

.popup-price-row {
  display: flex;
  align-items: center;
  min-height: 0.64rem;
  margin-top: -0.04rem;
}

.popup-operator {
  margin-right: 0.08rem;
}

::v-deep .activity-sku-popup {
  overflow: hidden;
}
</style>
